import { MdApps } from 'react-icons/md';
import { DropdownMenu, Flex, Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useModuleItems } from './hooks/useModuleItems';

export function ModulesDropdown() {
  const { t } = useTranslate('web-app');
  const { items } = useModuleItems();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-100 border-none bg-transparent cursor-pointer"
          title={t('modules.quick_access')}>
          <MdApps size={20} />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" className="min-w-[200px]">
        <Typography
          variant="body-sm-medium"
          className="px-2 py-1 text-gray-500">
          {t('modules.quick_access')}
        </Typography>
        <DropdownMenu.Separator />
        {items.map(item => (
          <DropdownMenu.Item key={item.label} className="p-0">
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 no-underline text-inherit px-2 py-1.5 w-full">
              {item.icon}
              <Flex direction="column">
                <Typography variant="body-sm-medium">{item.label}</Typography>
                <Typography
                  variant="metadata-xs-regular"
                  className="text-gray-500">
                  {item.subtitle}
                </Typography>
              </Flex>
            </a>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
